/** Local dev demo logins — must match server/automotive/seeds/*PortalDev.js defaults. */
export const AUTOMAP_DEALER_DEMO_CREDENTIALS = Object.freeze({
  email: "dealer-demo@automap.test",
  password: "ChangeMe123!",
});

export const AUTOMAP_PARTNER_DEMO_CREDENTIALS = Object.freeze({
  email: "partner-demo@automap.test",
  password: "ChangeMe123!",
});

export function isDevEnvironment() {
  return process.env.NODE_ENV === "development";
}
